import { DashboardData } from '@silo/types';
import { Array, Option, pipe } from 'effect';

export function getMarketsAtRiskOfLiquidation(data?: DashboardData): number {
  const marketsAtRiskOfLiquidation = pipe(
    data?.data,
    Option.fromNullable,
    Option.map((data) => data.dashboardMarkets),
    Option.map(Array.filter((market) => market.isAtRiskOfLiquidation)),
    Option.map((markets) => markets.length),
    Option.getOrElse(() => 0)
  );

  return marketsAtRiskOfLiquidation;
}
